import React from 'react'

const Footer = () => {
  return (
    <footer className='navbar navbar-dark bg-dark fixed-bottom'>
      <div className='container'>
        <div className='nav-item'>
          <p>&copy; Iury and Kate 2021</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer